export default "__VITE_ASSET__5972fe7a__"